import React, { useState, useEffect } from "react";
import { useEmailVerification, useResendEmailVerification } from "./api";
import { toast } from "react-toastify";

export default function TwoFactorAuthentication() {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [serverError, setServerError] = useState("");

  // Update to React Query v5 API
  const verificationMutation = useEmailVerification();

  const handleSubmit = (e: React.FormEvent) => {
    if (!navigator.onLine) {
      toast.error("No internet connection. Please check your network.");
      return;
    }
    e.preventDefault();
    setError("");
    if (!otp) {
      setError("Verification code is required");
      return;
    }

    verificationMutation.mutate(
      { otp },
      {
        onSuccess: (data) => {
          toast.success("Successfully logged in", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
          });
          window.location.href = "/dashboard";
        },
        onError: (err: any) => {
          setServerError(
            err.response?.data?.message ||
              "An error occurred during verification"
          );
        },
      }
    );
  };

  const resendMutation = useResendEmailVerification();

  const handleResend = () => {
    setError("");

    if (!navigator.onLine) {
      toast.error("No internet connection. Please check your network.");
      return;
    }

    // Send data to the server
    resendMutation.mutate(undefined, {
      onSuccess: (data) => {
        // Handle success response
        toast.success("A new verification code has been sent to your email.", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
        });
      },
      onError: (err: any) => {
        setServerError(
          err.response?.data?.message ||
            "A server error occurred during resend verification code"
        );
      },
    });
  };

  useEffect(() => {
    if (serverError) toast.error(serverError);
  }, [serverError]);

  return (
    <div className='flex justify-center'>
      <div className='flex-col border-solid border-2 border-[#D9D9D9] w-3/4 rounded-md flex items-center justify-center pt-6 pb-36 px-6 space-y-4 sm:w-3/4 md:w-1/2 lg:w-1/3'>
        <div className='flex flex-col justify-start w-full'>
          <h1 className='text-lg font-bold'>Verification Code</h1>
          <p className='text-sm mt-2'>
            Please enter the 6-digit code sent to your email
          </p>
        </div>

        <form onSubmit={handleSubmit} className='w-full'>
          <div className='flex flex-col w-full pt-3 pb-12'>
            <label htmlFor='otp' className='mb-1'>
              6-Digit Code
            </label>
            <input
              id='otp'
              autoComplete='one-time-code'
              autoFocus
              type='text'
              name='otp'
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ""))}
              className='border-solid border-2 border-[#D9D9D9] rounded-md outline-none px-2 py-1'
              placeholder='6-Digit Code'
              maxLength={6}
              pattern='[0-9]{6}'
              title='Please enter a 6-digit code'
            />
            {error && <p className='text-red-500 text-sm -mb-5'>{error}</p>}
          </div>
          <button
            type='submit'
            disabled={verificationMutation.isPending}
            className='bg-[#0275D8] text-white rounded-md w-full py-2 hover:bg-[#0256A1] disabled:bg-gray-400'
          >
            {verificationMutation.isPending ? "Verifying..." : "Submit"}
          </button>
        </form>

        <div className='flex flex-row items-start justify-start w-full py-3'>
          <button
            onClick={handleResend}
            style={resendMutation.isPending ? { color: "blue" } : {}}
            disabled={resendMutation.isPending}
            className='underline underline-offset-2 cursor-pointer text-left'
          >
            {resendMutation.isPending
              ? "Sending..."
              : "Resend Verification Code"}
          </button>
        </div>
      </div>
    </div>
  );
}
